import RouteTemplate from 'ember-route-template';
import { on } from '@ember/modifier';
import { fn } from '@ember/helper';
import eq from 'truth-helpers/helpers/eq';

const getStat = (stats, name) => stats ? stats[name] : null;

export default RouteTemplate(
  <template>
    <div class="admin-plugin-proxyviews pd-admin-unified-crud proxyviews-admin-dashboard">
      <div class="pd-admin-header">
        <div class="header-title-wrapper">
          <div>
            <h2>Analytics Dashboard</h2>
            <p class="description">Page views, engagement, affiliate, and content performance metrics. Read-only — this is telemetry collected from visitor activity, not admin-authored content.</p>
          </div>
        </div>
      </div>
    
      <div class="pd-drawer-tabs" style="margin-bottom: 24px;">
        {{#each @controller.reportTabs as |tab|}}
          <button type="button" class="tab {{if (eq @controller.activeTab tab) 'active'}}" {{on "click" (fn @controller.changeTab tab)}}>
            {{tab}}
          </button>
        {{/each}}
      </div>

      {{#if @controller.message}}
        <div class="pd-toast show {{if (eq @controller.message.type 'danger') 'error'}} {{if (eq @controller.message.type 'info') 'info'}} {{if (eq @controller.message.type 'success') 'success'}}">
          {{@controller.message.text}}
        </div>
      {{/if}}

      {{#if @controller.reportLoading}}
        <div class="pd-admin-search-status">Loading report…</div>
      {{/if}}
    
      {{#if (eq @controller.activeTab 'overview')}}
        <div class="pd-admin-stats">
          <div class="pd-admin-stat-card">
            <div class="pd-hub-stat"><span class="stat-label">Pageviews Today</span></div>
            <span class="stat-value">{{@controller.overview.pageviews.today}}</span>
          </div>
          <div class="pd-admin-stat-card">
            <div class="pd-hub-stat"><span class="stat-label">Pageviews (7d)</span></div>
            <span class="stat-value">{{@controller.overview.pageviews.last_7_days}}</span>
          </div>
          <div class="pd-admin-stat-card">
            <div class="pd-hub-stat"><span class="stat-label">Unique Visitors (7d)</span></div>
            <span class="stat-value">{{@controller.overview.unique_visitors.last_7_days}}</span>
          </div>
          <div class="pd-admin-stat-card">
            <div class="pd-hub-stat"><span class="stat-label">Affiliate Clicks (7d)</span></div>
            <span class="stat-value">{{@controller.overview.affiliate_clicks.last_7_days}}</span>
          </div>
        </div>
    
        <h3>Top Pages (30d)</h3>
        <div class="pd-admin-table-container margin-bottom-lg">
          <table class="pd-admin-table">
            <thead><tr><th scope="col">Type</th><th scope="col">Target ID</th><th scope="col">Views</th></tr></thead>
            <tbody>
              {{#each @controller.overview.top_pages as |p|}}
                <tr><td>{{p.target_type}}</td><td>{{p.target_id}}</td><td>{{p.views}}</td></tr>
              {{else}}
                <tr><td colspan="3" class="empty-results"><p>No page view data yet.</p></td></tr>
              {{/each}}
            </tbody>
          </table>
        </div>
    
        <h3>Top Providers by Views (30d)</h3>
        <div class="pd-admin-table-container">
          <table class="pd-admin-table">
            <thead><tr><th scope="col">Provider ID</th><th scope="col">Views</th></tr></thead>
            <tbody>
              {{#each @controller.overview.top_providers as |p|}}
                <tr><td>{{p.id}}</td><td>{{p.views}}</td></tr>
              {{else}}
                <tr><td colspan="2" class="empty-results"><p>No provider view data yet.</p></td></tr>
              {{/each}}
            </tbody>
          </table>
        </div>
      {{/if}}
    
      {{#if (eq @controller.activeTab 'pageviews')}}
        <div class="pd-admin-stats">
          <div class="pd-admin-stat-card">
            <div class="pd-hub-stat"><span class="stat-label">Total Pageviews</span></div>
            <span class="stat-value">{{@controller.pageviewsData.total_pageviews}}</span>
          </div>
          <div class="pd-admin-stat-card">
            <div class="pd-hub-stat"><span class="stat-label">Unique Pageviews</span></div>
            <span class="stat-value">{{@controller.pageviewsData.total_unique_pageviews}}</span>
          </div>
        </div>
        <h3>By Source</h3>
        <div class="pd-admin-table-container margin-bottom-lg">
          <table class="pd-admin-table">
            <thead><tr><th scope="col">Source</th><th scope="col">Views</th></tr></thead>
            <tbody>
              {{#each @controller.pageviewsSourceBreakdown as |e|}}
                <tr><td>{{e.name}}</td><td>{{e.count}}</td></tr>
              {{else}}
                <tr><td colspan="2" class="empty-results"><p>No data yet.</p></td></tr>
              {{/each}}
            </tbody>
          </table>
        </div>
        <h3>Top Pages</h3>
        <div class="pd-admin-table-container">
          <table class="pd-admin-table">
            <thead><tr><th scope="col">Type</th><th scope="col">Target ID</th><th scope="col">Views</th></tr></thead>
            <tbody>
              {{#each @controller.pageviewsData.top_pages as |p|}}
                <tr><td>{{p.target_type}}</td><td>{{p.target_id}}</td><td>{{p.views}}</td></tr>
              {{else}}
                <tr><td colspan="3" class="empty-results"><p>No data yet.</p></td></tr>
              {{/each}}
            </tbody>
          </table>
        </div>
      {{/if}}
    
      {{#if (eq @controller.activeTab 'content')}}
        <div class="pd-admin-stats">
          <div class="pd-admin-stat-card">
            <div class="pd-hub-stat"><span class="stat-label">Total Content Views</span></div>
            <span class="stat-value">{{@controller.contentData.total_content_views}}</span>
          </div>
          <div class="pd-admin-stat-card">
            <div class="pd-hub-stat"><span class="stat-label">Guide Avg. Scroll Depth</span></div>
            <span class="stat-value">{{@controller.contentData.engagement.guides.average_scroll_depth}}%</span>
          </div>
          <div class="pd-admin-stat-card">
            <div class="pd-hub-stat"><span class="stat-label">Comparison Avg. Scroll Depth</span></div>
            <span class="stat-value">{{@controller.contentData.engagement.comparisons.average_scroll_depth}}%</span>
          </div>
          <div class="pd-admin-stat-card">
            <div class="pd-hub-stat"><span class="stat-label">Benchmark Avg. Scroll Depth</span></div>
            <span class="stat-value">{{@controller.contentData.engagement.benchmarks.average_scroll_depth}}%</span>
          </div>
        </div>
        <h3>Views by Content Type</h3>
        <div class="pd-admin-table-container margin-bottom-lg">
          <table class="pd-admin-table">
            <thead><tr><th scope="col">Type</th><th scope="col">Views</th></tr></thead>
            <tbody>
              {{#each @controller.contentViewsByType as |e|}}
                <tr><td>{{e.name}}</td><td>{{e.count}}</td></tr>
              {{else}}
                <tr><td colspan="2" class="empty-results"><p>No data yet.</p></td></tr>
              {{/each}}
            </tbody>
          </table>
        </div>
        <h3>Top Guides</h3>
        <div class="pd-admin-table-container margin-bottom-lg">
          <table class="pd-admin-table">
            <thead><tr><th scope="col">Guide ID</th><th scope="col">Views</th></tr></thead>
            <tbody>
              {{#each @controller.contentData.guides as |g|}}
                <tr><td>{{g.id}}</td><td>{{g.views}}</td></tr>
              {{else}}
                <tr><td colspan="2" class="empty-results"><p>No data yet.</p></td></tr>
              {{/each}}
            </tbody>
          </table>
        </div>
        <h3>Top Comparisons</h3>
        <div class="pd-admin-table-container">
          <table class="pd-admin-table">
            <thead><tr><th scope="col">Comparison ID</th><th scope="col">Views</th></tr></thead>
            <tbody>
              {{#each @controller.contentData.comparisons as |c|}}
                <tr><td>{{c.id}}</td><td>{{c.views}}</td></tr>
              {{else}}
                <tr><td colspan="2" class="empty-results"><p>No data yet.</p></td></tr>
              {{/each}}
            </tbody>
          </table>
        </div>
      {{/if}}
    
      {{#if (eq @controller.activeTab 'affiliates')}}
        <div class="pd-admin-stats">
          <div class="pd-admin-stat-card">
            <div class="pd-hub-stat"><span class="stat-label">Total Clicks</span></div>
            <span class="stat-value">{{@controller.affiliatesData.total_clicks}}</span>
          </div>
          <div class="pd-admin-stat-card">
            <div class="pd-hub-stat"><span class="stat-label">Est. Conversions</span></div>
            <span class="stat-value">{{@controller.affiliatesData.estimated_conversions}}</span>
          </div>
          <div class="pd-admin-stat-card">
            <div class="pd-hub-stat"><span class="stat-label">Est. Conversion Rate</span></div>
            <span class="stat-value">{{@controller.affiliatesData.estimated_conversion_rate}}%</span>
          </div>
        </div>
        <h3>Clicks by Provider</h3>
        <div class="pd-admin-table-container margin-bottom-lg">
          <table class="pd-admin-table">
            <thead><tr><th scope="col">Provider ID</th><th scope="col">Clicks</th></tr></thead>
            <tbody>
              {{#each @controller.affiliatesData.clicks_by_provider as |p|}}
                <tr><td>{{p.provider_id}}</td><td>{{p.clicks}}</td></tr>
              {{else}}
                <tr><td colspan="2" class="empty-results"><p>No data yet.</p></td></tr>
              {{/each}}
            </tbody>
          </table>
        </div>
        <h3>Clicks by Source</h3>
        <div class="pd-admin-table-container margin-bottom-lg">
          <table class="pd-admin-table">
            <thead><tr><th scope="col">Source</th><th scope="col">Clicks</th></tr></thead>
            <tbody>
              {{#each @controller.affiliatesClicksBySource as |e|}}
                <tr><td>{{e.name}}</td><td>{{e.count}}</td></tr>
              {{else}}
                <tr><td colspan="2" class="empty-results"><p>No data yet.</p></td></tr>
              {{/each}}
            </tbody>
          </table>
        </div>
        <h3>Country Breakdown</h3>
        <div class="pd-admin-table-container">
          <table class="pd-admin-table">
            <thead><tr><th scope="col">Country</th><th scope="col">Clicks</th></tr></thead>
            <tbody>
              {{#each @controller.affiliatesCountryBreakdown as |e|}}
                <tr><td>{{e.name}}</td><td>{{e.count}}</td></tr>
              {{else}}
                <tr><td colspan="2" class="empty-results"><p>No data yet.</p></td></tr>
              {{/each}}
            </tbody>
          </table>
        </div>
      {{/if}}
    
      {{#if (eq @controller.activeTab 'users')}}
        <div class="pd-admin-stats">
          <div class="pd-admin-stat-card">
            <div class="pd-hub-stat"><span class="stat-label">Active Users</span></div>
            <span class="stat-value">{{@controller.usersData.active_users}}</span>
          </div>
          <div class="pd-admin-stat-card">
            <div class="pd-hub-stat"><span class="stat-label">New Users</span></div>
            <span class="stat-value">{{@controller.usersData.new_users}}</span>
          </div>
          <div class="pd-admin-stat-card">
            <div class="pd-hub-stat"><span class="stat-label">Returning Users</span></div>
            <span class="stat-value">{{@controller.usersData.returning_users}}</span>
          </div>
          <div class="pd-admin-stat-card">
            <div class="pd-hub-stat"><span class="stat-label">Engagement Rate</span></div>
            <span class="stat-value">{{@controller.usersData.engagement_rate}}%</span>
          </div>
          <div class="pd-admin-stat-card">
            <div class="pd-hub-stat"><span class="stat-label">Avg. Session (s)</span></div>
            <span class="stat-value">{{@controller.usersData.average_session_duration_seconds}}</span>
          </div>
        </div>
        <h3>Top Searches</h3>
        <div class="pd-admin-table-container">
          <table class="pd-admin-table">
            <thead><tr><th scope="col">Query</th><th scope="col">Count</th></tr></thead>
            <tbody>
              {{#each @controller.usersTopSearches as |e|}}
                <tr><td>{{e.name}}</td><td>{{e.count}}</td></tr>
              {{else}}
                <tr><td colspan="2" class="empty-results"><p>No searches yet.</p></td></tr>
              {{/each}}
            </tbody>
          </table>
        </div>
      {{/if}}
    
      {{#if (eq @controller.activeTab 'funnels')}}
        <h3>Latest Funnel — {{@controller.funnelsData.funnel_name}}</h3>
        <div class="pd-admin-table-container">
          <table class="pd-admin-table">
            <thead><tr><th scope="col">Step</th><th scope="col">Users</th><th scope="col">Events</th><th scope="col">Conversion</th><th scope="col">Drop-off</th></tr></thead>
            <tbody>
              {{#each @controller.funnelsData.latest_funnel as |s|}}
                <tr>
                  <td>{{s.step_name}}</td>
                  <td>{{s.user_count}}</td>
                  <td>{{s.event_count}}</td>
                  <td>{{s.conversion_rate}}%</td>
                  <td>{{s.drop_off_rate}}%</td>
                </tr>
              {{else}}
                <tr><td colspan="5" class="empty-results"><p>No funnel data computed yet.</p></td></tr>
              {{/each}}
            </tbody>
          </table>
        </div>
      {{/if}}
    
      {{#if (eq @controller.activeTab 'cohorts')}}
        <h3>Weekly Retention Cohorts</h3>
        <div class="pd-admin-table-container">
          <table class="pd-admin-table">
            <thead><tr><th scope="col">Cohort</th><th scope="col">Size</th><th scope="col">Week 1</th><th scope="col">Week 4</th><th scope="col">Week 12</th></tr></thead>
            <tbody>
              {{#each @controller.cohortsData.cohorts as |c|}}
                <tr>
                  <td>{{c.cohort_date}}</td>
                  <td>{{c.cohort_size}}</td>
                  <td>{{c.retention.week_1.rate}}%</td>
                  <td>{{c.retention.week_4.rate}}%</td>
                  <td>{{c.retention.week_12.rate}}%</td>
                </tr>
              {{else}}
                <tr><td colspan="5" class="empty-results"><p>No cohorts computed yet.</p></td></tr>
              {{/each}}
            </tbody>
          </table>
        </div>
      {{/if}}

      {{#if (eq @controller.activeTab 'experiments')}}
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
          <h3>A/B Experiments</h3>
          <button type="button" class="btn btn-primary" {{on "click" (fn @controller.editExperiment null)}}>New Experiment</button>
        </div>

        {{#if @controller.isEditingExperiment}}
          <div class="pd-admin-box">
            <h4>{{if @controller.editingExperiment.id "Edit Experiment" "Create Experiment"}}</h4>
            <form class="form-horizontal">
              <div class="control-group">
                <label>Name</label>
                <div class="controls">
                  {{!-- template-lint-disable require-input-label --}}
                  <input type="text" value={{@controller.editingExperiment.name}} {{on "input" (fn @controller.setField "name")}} placeholder="e.g. directory_cta_color" class="input-large" />
                </div>
              </div>
              <div class="control-group">
                <label>Description</label>
                <div class="controls">
                  <input type="text" value={{@controller.editingExperiment.description}} {{on "input" (fn @controller.setField "description")}} class="input-large" />
                </div>
              </div>
              <div class="control-group">
                <label>Status</label>
                <div class="controls">
                  <select {{on "change" (fn @controller.setField "status")}}>
                    <option value="draft" selected={{eq @controller.editingExperiment.status "draft"}}>Draft</option>
                    <option value="active" selected={{eq @controller.editingExperiment.status "active"}}>Active</option>
                    <option value="completed" selected={{eq @controller.editingExperiment.status "completed"}}>Completed</option>
                  </select>
                </div>
              </div>
              <div class="control-group">
                <label>Traffic Allocation (%)</label>
                <div class="controls">
                  <input type="number" min="0" max="100" value={{@controller.editingExperiment.traffic_allocation}} {{on "input" (fn @controller.setField "traffic_allocation")}} class="input-small" />
                </div>
              </div>
              
              <div class="control-group">
                <label>Variants</label>
                <div class="controls">
                  <table class="pd-admin-table" style="margin-bottom: 10px;">
                    <thead><tr><th scope="col">Name</th><th scope="col">Weight</th><th scope="col">JSON Payload</th><th scope="col"></th></tr></thead>
                    <tbody>
                      {{#each @controller.editingExperiment.variants as |v index|}}
                        <tr>
                          <td><input type="text" value={{v.name}} {{on "input" (fn @controller.updateVariantField index "name")}} class="input-small" /></td>
                          <td><input type="number" value={{v.weight}} {{on "input" (fn @controller.updateVariantField index "weight")}} class="input-small" style="width: 60px;" /></td>
                          <td><input type="text" value={{v.payload}} {{on "input" (fn @controller.updateVariantPayload index)}} class="input-large" placeholder="{}" /></td>
                          <td><button type="button" class="btn btn-danger btn-small" {{on "click" (fn @controller.removeVariant index)}}>X</button></td>
                        </tr>
                      {{/each}}
                    </tbody>
                  </table>
                  <button type="button" class="btn btn-default" {{on "click" @controller.addVariant}}>Add Variant</button>
                </div>
              </div>

              <div class="control-group" style="margin-top: 20px;">
                <button type="button" class="btn btn-primary" {{on "click" @controller.saveExperiment}}>Save</button>
                <button type="button" class="btn" {{on "click" @controller.cancelEditExperiment}}>Cancel</button>
              </div>
            </form>
          </div>
        {{else}}
          <div class="pd-admin-table-container">
            <table class="pd-admin-table">
              <thead><tr><th scope="col">Name</th><th scope="col">Status</th><th scope="col">Traffic</th><th scope="col">Variants / Event Counts</th><th scope="col">Actions</th></tr></thead>
              <tbody>
                {{#each @controller.experimentsData as |e|}}
                  <tr>
                    <td><strong>{{e.name}}</strong><br /><span style="color:#666; font-size:12px;">{{e.description}}</span></td>
                    <td><span class="badge {{if (eq e.status 'active') 'badge-success' 'badge-default'}}">{{e.status}}</span></td>
                    <td>{{e.traffic_allocation}}%</td>
                    <td>
                      {{#each e.variants as |v|}}
                        <div>{{v.name}} (weight: {{v.weight}}): <strong>{{getStat e.stats v.name}}</strong></div>
                      {{/each}}
                    </td>
                    <td>
                      <button type="button" class="btn btn-default btn-small" {{on "click" (fn @controller.editExperiment e)}}>Edit</button>
                      <button type="button" class="btn btn-danger btn-small" {{on "click" (fn @controller.deleteExperiment e)}}>Delete</button>
                    </td>
                  </tr>
                {{/each}}
                {{#unless @controller.experimentsData.length}}
                  <tr><td colspan="5" class="empty-results"><p>No A/B experiments configured yet.</p></td></tr>
                {{/unless}}
              </tbody>
            </table>
          </div>
        {{/if}}
      {{/if}}
    </div>
  </template>
);
